export const FULLY_CANCELLEED= 'fully cancelled';
